<template>
  <v-container fluid>
    <v-row>
      <v-col order-md="1" align="left">
        <v-icon class="pb-6 pt-4" style="color: black">shopping_cart</v-icon
        ><span class="pl-3 pb-8" style="font-size: 12px; font-weight: bold;"
          >MES COMMANDES</span
        >

        <v-card class="pt-2 pb-2 pl-5">
          <router-link
            :to="{
              name: 'listeCommandeDemandeur',
              params: {
                statutCommandeIP: 'NA'
              }
            }"
          >
            <v-avatar
              class="accent oval"
              size="50"
              style=" border-top-left-radius: 25px;  border-top-right-radius: 25px;"
            >
              <span>
                {{ commandeQte.qteCommandeDuJour }}
              </span>
            </v-avatar>
            <span class="button pl-5 pr-5">Commandes de la journée</span>
            <v-icon>arrow_forward</v-icon>
          </router-link>
        </v-card>

        <v-card class="pt-2 pb-2 pl-5">
          <router-link
            :to="{
              name: 'listeCommandeDemandeur',
              params: {
                statutCommandeIP: 'EN_TRAITEMENT'
              }
            }"
          >
            <v-avatar
              class="accent oval"
              size="50"
              style=" border-top-left-radius: 25px;  border-top-right-radius: 25px;"
            >
              <span>
                {{ commandeQte.qteCommandeStatutEnTraitement }}
              </span>
            </v-avatar>
            <span class="button pl-5 pr-5"
              >Commandes transmises - non confirmées</span
            >
            <v-icon>arrow_forward</v-icon>
          </router-link>
        </v-card>

        <v-card class="pt-2 pb-2 pl-5">
          <router-link
            :to="{
              name: 'listeCommandeDemandeur',
              params: { statutCommandeIP: 'BROUILLON' }
            }"
          >
            <v-avatar
              class="accent"
              size="50"
              style=" border-top-left-radius: 25px;  border-top-right-radius: 25px;"
            >
              <span>
                {{ commandeQte.qteCommandeStatutBrouillon }}
              </span>
            </v-avatar>

            <span
              v-if="commandeQte.indCommandeBrouillonDateJour == true"
              class="button pl-5 pr-5"
              style="color: red"
            >
              Commandes en brouillon</span
            >
            <span v-else class="button pl-5 pr-5"> Commandes en brouillon</span>

            <v-icon>arrow_forward</v-icon>
          </router-link>
        </v-card>

        <v-row
          v-if="
            this.$store.getters.currentUser != null &&
              this.$store.getters.currentUser.agentData.indCapaciteFinanciere
          "
          class="pt-10"
        >
          <v-col cols="6" sm="3">
            <v-btn
              :to="{ name: 'capaciteFinanciere' }"
              text
              large
              style="text-transform: none;"
              class="accent"
            >
              <v-icon text class="pr-3">monetization_on</v-icon>
              <span class="pl-5 pr-10" style="font-size: 16px;"
                >Capacité financière</span
              >
            </v-btn>
          </v-col>
        </v-row>

        <v-row v-if="this.$store.getters.currentUser != null" class="pt-0">
          <v-col cols="6" sm="3">
            <v-btn
              :to="{ name: 'capaciteAchat' }"
              text
              large
              style="text-transform: none;"
              class="accent"
            >
              <v-icon text class="pr-3">add_chart</v-icon>
              <span class="pl-5 pr-10" style="font-size: 16px;"
                >Calcul capacité d'achat</span
              >
            </v-btn>
          </v-col>
        </v-row>
      </v-col>

      <!-- ------------- -->
      <!--Communications -->
      <!-- ------------- -->

      <v-col cols="12" xs="1" md="8" align-self="center">
        <v-container pl-5>
          <template>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="communication.communication"></div
          ></template>

          <v-data-iterator
            :items="fichiers"
            hide-default-footer
            dense
            no-data-text=""
          >
            <template v-slot:default="props">
              <div v-if="fichiers != null" class="pt-8 font-weight-bold">
                Documents d'informations
              </div>
              <v-col v-for="item in props.items" :key="item.name" lg="12">
                <a
                  style="text-decoration: underline; color: #343232; font-weight: bold;  color: black"
                  class="text-caption text-capitalize"
                  @click="exportFichier(item)"
                  >{{ item.nomFichier }}</a
                >
              </v-col>
            </template>
          </v-data-iterator>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Accueil',
  data() {
    return {
      fichiers: [],
      commandeQte: {},
      communication: { communication: null }
    }
  },
  computed: {
    agentConnecte: function() {
      return this.$store.getters.agentConnecte
    },
    nom: function() {
      return this.$store.getters.agentConnecteInfosJDE.nom
    }
  },

  beforeMount() {
    axios
      .get(`/commandesip/${this.agentConnecte.idDemandeur}/qte`)
      .then(response => {
        let resp = response.data
        switch (resp.codeRetour) {
          case 'OK':
            this.commandeQte = resp.resultat
            break
          default:
            console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
            this.$store.dispatch(
              'afficherError',
              `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
            )
            break
        }
      })
      .catch(error => {
        //console.log('error=' + error)
        let texte = ''
        if (error.response) {
          texte = `Status: ${error.response.status} Data: ${error.response.data}`
          console.log(texte)
        } else {
          texte = `Une erreur technique est survenue: ${error.message}`
        }
        this.$store.dispatch('afficherError', texte)
      })

    axios
      .get(`/communication/selontype/${'AGENT'}`)
      .then(response => {
        let resp = response.data
        switch (resp.codeRetour) {
          case 'OK':
            this.communication = resp.resultat
            this.lireDocuments()
            break
          default:
            console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
            this.$store.dispatch(
              'afficherError',
              `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
            )
            break
        }
      })
      .catch(error => {
        //console.log('error=' + error)
        let texte = ''
        if (error.response) {
          texte = `Status: ${error.response.status} Data: ${error.response.data}`
          console.log(texte)
        } else {
          texte = `Une erreur technique est survenue: ${error.message}`
        }
        this.$store.dispatch('afficherError', texte)
      })
  },

  methods: {
    lireDocuments() {
      axios
        .get(`/communication/obtenirfichiers/${this.communication.id}`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.fichiers = resp.resultat
              break
            case 'W001':
              this.fichiers = []
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },
    exportFichier(fichier) {
      axios({
        url: '/communication/' + fichier.id + '/fichier',
        method: 'get',
        responseType: 'arraybuffer',
        //headers: { Accept: 'application/pdf' }
      })
        .then(response => {
          let ct = response.headers['content-type']
         // if (ct == 'application/json') {
         //   const str = new TextDecoder().decode(response.data)
          //  const resp = JSON.parse(str)
          //  const msg = this.$fmtApiErr(resp)
         //   console.log(msg)
          //  this.$store.dispatch('afficherError', msg)
          //} else {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fichier.nomFichier)
            document.body.appendChild(link)
            link.click()
          //}
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    }
  }
}
</script>

<style scoped>
.header {
  padding: 4px;
  text-align: left;
  color: white;
  font-size: 20px;
  width: 1500px;
}

.button {
  color: #343232;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.43px;
  line-height: 12px;
}

.v-application a {
  color: white;
}

.oval {
  height: 50.81px;
  width: 50.81px;
  background-color: #00838e;
}
</style>
